import type {HTMLAttributes} from 'react'

import {cn} from '@/lib/utils'

export function CardHeader({className, ...props}: HTMLAttributes<HTMLDivElement>) {
  return <div data-slot="card-header" className={cn('grid gap-1.5 border-b px-5 py-4', className)} {...props} />
}
